import Store from "../../../Store/Store";

class AgencyFeeContainer {
  public pickIdFromLabel(label) {
    const agencyFee = Store.getConfigurator().getState().globalTypes?.AgencyFeeObjectType;
    for(const key in agencyFee) {
      if (agencyFee[key].label === label) {
        return agencyFee[key].id
      }
    }
  }
}

export default new AgencyFeeContainer();
